import styles from './LanguageBtn.module.scss';
import cn from 'classnames';

import { useLocation } from 'react-router-dom';
import { instance } from 'utils';
import { changeLanguage } from 'i18next';
import { Icon } from 'components';

import fr from 'assets/sprite/fr.svg';
import en from 'assets/sprite/en.svg';

export interface LanguageBtnProps {
  language: string;
}

export const LanguageBtn = ({ language }) => {
  const router = useLocation();
  const loginPage = router.pathname === '/';
  const resetPasswordPage = router.pathname === '/reset-password';

  const patchUserLanguage = lang => {
    if (!loginPage && !resetPasswordPage) {
      instance.patch(`/users/me`, { language: lang });
    }
    changeLanguage(lang);
  };

  const getLanguageIcon = lang => {
    switch (lang) {
      case 'fr-FR':
        return fr;
      default:
      case 'en-US':
        return en;
    }
  };

  const getCurrentLanguage = localStorage.getItem('i18nextLng');

  const checkActiveLanguage = () => {
    if (language === getCurrentLanguage) {
      return styles.active;
    }
    return '';
  };

  return (
    <button
      className={cn(styles.flagBtn, checkActiveLanguage())}
      onClick={() => {
        patchUserLanguage(language);
      }}
    >
      <Icon id={getLanguageIcon(language).id} viewBox={getLanguageIcon(language).viewBox} />
    </button>
  );
};
